/*
 * Define default theme
 *
 * https://styled-components.com/docs/advanced#theming
 */
import { IDefaultTheme } from 'styled-components';

const theme: IDefaultTheme = {
  colors: {
    white: '#ffffff',
    primary: '#32bfa3',
    lighter: '#f2f3f8',
    light: '#ebedf2',
    gray: '#ced4da',
    dark: '#575962',
    darker: '#2c2e3e',
    violet: '#716aca',
    navbarLink: '#676c7b',
  },

  boxShadow: '0px 1px 15px 1px rgb(69 65 78 / 10%)',
  borderRadius: '3px',

  breakpoints: {
    sm: '(max-width: 576px)',
    md: '(max-width: 768px)',
    lg: '(max-width: 992px)',
    xl: '(max-width: 1200px)',
  },
};

export default theme;
